<template>
	<div class="container__politica_de_privacidade">
		<div class="container__politica_de_privacidade__main">
			<div class="container__politica_de_privacidade__main__panel">
				<img
					src="../../assets/treevia_login.png"
					alt
					class="container__politica_de_privacidade__main__panel__logo"
				/>
				<div class="container__politica_de_privacidade_body">
					<div class="container__politica_de_privacidade_title">
						Política de Privacidade<br />
						Treevia Forest Technologies
					</div>
					A presente Política de Privacidade contém informações sobre coleta, uso, armazenamento,
					tratamento e proteção dos dados pessoais dos usuários e visitantes do site da empresa
					Treevia Serviços de Engenharia Ltda, com a finalidade de demonstrar absoluta transparência
					quanto ao assunto e esclarecer a todos interessados sobre os tipos de dados que são
					coletados, os motivos da coleta e a forma como os usuários podem gerenciar ou excluir as
					suas informações pessoais. O presente documento foi elaborado em conformidade com a Lei
					Geral de Proteção de Dados Pessoais (Lei 13.709/18), o Marco Civil da Internet (Lei
					12.965/14) (e o Regulamento da UE n. 2016/6790). Ainda, o documento poderá ser atualizado
					em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a
					consultar periodicamente esta seção.
					<div class="container__politica_de_privacidade_subtitle">
						2 – SOBRE OS DADOS COLETADOS<br />
						2.1 – DADOS PESSOAIS FORNECIDOS PELO USUÁRIO
					</div>
					Os dados pessoais podem ser coletados diretamente por simples disponibilização a um
					funcionário do(a) Treevia quando do preenchimento de cadastro ou acordos comerciais, bem,
					como mediante a interação em nossas plataformas.
					<div class="container__politica_de_privacidade_subtitle">
						2.2 – QUAIS DADOS SÃO COLETADOS
					</div>
					O(a) Treevia coleta informações de modo automático em suas plataformas de interação com o
					Usuário, tais como: Nome Completo, CPF, E-mail e Telefone; endereço de IP e Cookies.
					<div class="container__politica_de_privacidade_subtitle">
						3 – PARA QUE FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USUÁRIO E VISITANTE?
					</div>
					Os dados pessoais tratados pelo(a) Treevia têm como principais finalidades a possibilidade
					do Usuário conhecer a oferta de produtos e serviços Treevia, o fornecimento de informações
					via formulário de contato ou pelo corretor online, identificar os Usuários que navegam no
					site e manter os dados de Usuários atualizados. Os dados poderão ser utilizados: Bem-estar
					do usuário e visitante: aprimorar o produto e/ou serviço oferecido, facilitar, agilizar e
					cumprir os compromissos estabelecidos entre o usuário e a empresa, melhorar a experiência
					dos usuários e fornecer funcionalidades específicas a depender das características básicas
					do usuário. Melhorias da plataforma: compreender como o usuário utiliza os serviços da
					plataforma, para ajudar no desenvolvimento de negócios e técnicas. Anúncios: apresentar
					anúncios personalizados para o usuário com base nos dados fornecidos. Comercial: os dados
					são usados para personalizar o conteúdo oferecido e gerar subsídio à plataforma para a
					melhora da qualidade no funcionamento dos serviços. Previsão do perfil do usuário:
					tratamento automatizados de dados pessoais para avaliar o uso na plataforma. Dados de
					cadastro: para permitir o acesso do usuário a determinados conteúdos da plataforma,
					exclusivo para usuários cadastrados Dados de contrato: conferir às partes segurança
					jurídica e facilitar a conclusão do negócio. Outras Em alguns casos, poderá tratar seus
					dados pessoais quando necessários para o cumprimento de obrigação legal ou exercício
					regular de direitos em processo judicial, administrativo ou arbitral. Além disso, também
					poderá tratar dados pessoais com base em seu interesse legítimo, sempre no limite de sua
					expectativa, e nunca em prejuízo de seus interesses, direitos e liberdades fundamentais.
					<div class="container__politica_de_privacidade_subtitle">
						4 – COM QUEM OS DADOS SÃO COMPARTILHADOS
					</div>
					Com autoridades judiciais, administrativas ou governamentais competentes, sempre que
					houver determinação legal, requerimento, requisição ou ordem judicial; Com instituições
					responsáveis por cobrar o crédito decorrente da aquisição da(s) unidade(s) imobiliária(s)
					que você adquiriu; Com o corretor de imóveis, quando a compra for intermediada;
					Instituições financeiras de financiamento de imóvel; Com a administradora do condomínio,
					que prestará os serviços de gestão e administração do empreendimento; e De forma
					automática, em caso de movimentações societárias, como fusão, aquisição e incorporação.
					Securitização de recebíveis
					<div class="container__politica_de_privacidade_subtitle">
						5 – POR QUANTO TEMPO OS DADOS PESSOAIS FICAM ARMAZENADOS?
					</div>
					Os dados pessoais do usuário e visitante são armazenados pela plataforma durante o período
					necessário para a prestação do serviço ou o cumprimento das finalidades previstas no
					presente documento, conforme o disposto no inciso I do artigo 15 da Lei 13.709/18. Os
					dados podem ser removidos ou anonimizados a pedido do usuário, excetuando os casos em que
					a lei oferecer outro tratamento. Ainda, os dados pessoais dos usuários apenas podem ser
					conservados após o término de seu tratamento nas seguintes hipóteses previstas no artigo
					16 da referida lei: I – cumprimento de obrigação legal ou regulatória pelo controlador; II
					– estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados
					pessoais; III – transferência a terceiro, desde que respeitados os requisitos de
					tratamento de dados dispostos nesta Lei; IV – uso exclusivo do controlador, vedado seu
					acesso por terceiro, e desde que anonimizados os dados.
					<div class="container__politica_de_privacidade_subtitle">
						6 – SEGURANÇA DOS DADOS PESSOAIS ARMAZENADOS
					</div>
					O(a) Treevia se compromete a aplicar as medidas técnicas e organizativas aptas a proteger
					os dados pessoais de acessos não autorizados e de situações de destruição, perda,
					alteração, comunicação ou difusão de tais dados. O(a) Treevia não se exime de
					responsabilidade por culpa exclusiva de terceiro, como em caso de ataque de hackers ou
					crackers, ou culpa exclusiva do usuário, como no caso em que ele mesmo transfere seus
					dados a terceiros, comprometendo-se a comunicar o usuário em caso de alguma violação de
					segurança dos seus dados pessoais. Os dados pessoais armazenados são tratados com
					confidencialidade, dentro dos limites legais. No entanto, podemos divulgar suas
					informações pessoais caso sejamos obrigados pela lei para fazê-lo ou se você violar nossos
					Termos de Serviço.
					<div class="container__politica_de_privacidade_subtitle">
						7 – COOKIES OU DADOS DE NAVEGAÇÃO
					</div>
					Os cookies referem-se a arquivos de texto enviados pela plataforma ao computador do
					usuário e visitante e que nele ficam armazenados, com informações relacionadas à navegação
					no site. Tais informações são relacionadas aos dados de acesso como local e horário de
					acesso e são armazenadas pelo navegador do usuário e visitante para que o servidor da
					plataforma possa lê-las posteriormente a fim de personalizar os serviços da plataforma. O
					usuário e o visitante do site manifesta conhecer e aceitar que pode ser utilizado um
					sistema de coleta de dados de navegação mediante à utilização de cookies. O cookie
					persistente permanece no disco rígido do usuário e visitante depois que o navegador é
					fechado e será usado pelo navegador em visitas subsequentes ao site. Os cookies
					persistentes podem ser removidos seguindo as instruções do seu navegador. Já o cookie de
					sessão é temporário e desaparece depois que o navegador é fechado. É possível redefinir
					seu navegador da web para recusar todos os cookies, porém alguns recursos da plataforma
					podem não funcionar corretamente se a capacidade de aceitar cookies estiver desabilitada.
					<div class="container__politica_de_privacidade_subtitle">8 – CONSENTIMENTO</div>
					Ao utilizar os serviços e fornecer as informações pessoais na plataforma, o usuário está
					consentindo com a presente Política de Privacidade. O usuário, ao cadastrar-se, manifesta
					conhecer e pode exercitar seus direitos de cancelar seu cadastro, acessar e atualizar seus
					dados pessoais e garante a veracidade das informações por ele disponibilizadas. O usuário
					tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve entrar em
					contato com nosso escritório.
					<div class="container__politica_de_privacidade_subtitle">
						9 – ALTERAÇÕES PARA ESSA POLÍTICA DE PRIVACIDADE
					</div>
					Reservamos o direito de modificar essa Política de Privacidade a qualquer momento, então,
					é recomendável que o usuário e visitante revise-a com frequência. As alterações e
					esclarecimentos vão surtir efeito imediatamente após sua publicação na plataforma. Quando
					realizadas alterações os usuários serão notificados. Ao utilizar o serviço ou fornecer
					informações pessoais após eventuais modificações, o usuário e visitante demonstra sua
					concordância com as novas normas. Diante da fusão ou venda da plataforma à outra empresa
					os dados dos usuários podem ser transferidas para os novos proprietários para que a
					permanência dos serviços oferecidos.
					<div class="container__politica_de_privacidade_subtitle">
						10 – JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS
					</div>
					Para a solução de controvérsias decorrentes do presente instrumento será aplicado
					integralmente o Direito brasileiro. Os eventuais litígios deverão ser apresentados no foro
					da comarca em que se encontra a sede da empresa.
				</div>
			</div>
		</div>
		<div class="container__politica_de_privacidade__footer">
			<Footer />
		</div>
	</div>
</template>

<script>
import Footer from '../../components/Footer/Footer'
export default {
	components: {
		Footer,
	},
}
</script>

<style scoped>
.container__politica_de_privacidade {
	display: grid;
	grid-template-areas: 'main' 'footer';
	background-color: white;
	width: 100%;
}

.container__politica_de_privacidade_title {
	font-size: 18px;
	font-weight: 700;
	text-align: center;
	margin-bottom: 1rem;
	color: rgb(var(--color-primary));
}

.container__politica_de_privacidade_subtitle {
	font-size: 16px;
	font-weight: 500;
	margin-top: 1rem;
	margin-bottom: 1rem;
}

.container__politica_de_privacidade_body {
	height: 55vh;
	overflow-y: scroll;
	margin-top: 1rem;
}

.container__politica_de_privacidade__main {
	grid-area: main;
	height: calc(100vh - 2.5rem);
	display: flex;
	justify-content: center;
	align-items: center;
}

.container__politica_de_privacidade__main__panel__logo {
	max-width: 100%;
	width: 200px;
	margin: 0 auto;
}

.container__politica_de_privacidade__footer {
	grid-area: footer;
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

@media screen and (min-width: 768px) {
	.container__politica_de_privacidade {
		background-color: var(--color-background);
	}

	.container__politica_de_privacidade__main__panel {
		background-color: white;
		border-radius: 5px;
		width: 70vw;
		padding: 2.5rem 3.12rem;
		height: 80vh;
	}
}
</style>
